import React from 'react'

import useAxios from 'hooks/useAxios'
import PushContactCustomFieldIntegration from '.'
import { Loader } from 'shared/components/Loader'

export default function PushContactCustomFieldIntegrationContainer({
  isAuthenticated,
  integrationSetting,
  updateCompanyIntegrationSetting,
  updateCompanyIntegrationSettingAPILoading,
}) {
  const { data: surveyIntegrationSettings } = useAxios({
    url: 'survey/survey-integration-setting/by-integration/?integration_type=intercom&name=push_contact_custom_field',
  })
  const {
    data: contactCustomFields,
    fetch: resyncContactField,
    loading: resyncContactFieldLoading,
  } = useAxios({
    url: 'intercom/contact-custom-field-sync-options/',
    skip: !isAuthenticated,
  })

  function activateIntegration() {
    updateCompanyIntegrationSetting(integrationSetting, true)
  }
  function deactivateIntegration() {
    updateCompanyIntegrationSetting(integrationSetting, false)
  }

  if (!surveyIntegrationSettings) {
    return <Loader withContainer />
  }

  return (
    <PushContactCustomFieldIntegration
      isAuthenticated={isAuthenticated}
      integrationSetting={integrationSetting}
      activateIntegration={activateIntegration}
      deactivateIntegration={deactivateIntegration}
      surveyIntegrationSettings={surveyIntegrationSettings}
      updateCompanyIntegrationSettingAPILoading={updateCompanyIntegrationSettingAPILoading}
      contactCustomFields={contactCustomFields || []}
      resyncContactField={resyncContactField}
      resyncContactFieldLoading={resyncContactFieldLoading}
    />
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/IntercomPushContactCustomFieldIntegration/container.js